<template>
  <div class="mine">
    <div class="mine-top">
      <img src="./img/infoLogo.png" alt="" />
      <div class="mine-top-cont">
        <div class="mine-name">
          {{ greetings }}， {{ userInfo.fullName }}，祝您开心每一天！
        </div>
        <div class="mine-duty">
          {{ getByTypeName(userInfo.dutiesVal, dutiesValList) }}
          <a-divider type="vertical" />
          {{ userInfo.organizationNamePath }}
        </div>
      </div>
    </div>
    <div class="oa-layout-content">
      <div class="changepassword">修改密码</div>
      <blank height="20"> </blank>
      <prompts> 密码由6-8位的大小写字母和数字组成 </prompts>

      <blank height="20"> </blank>
      <a-form-model v-bind="layout">
        <!-- <a-form-model-item label="原密码">
          <a-input-password
            v-model="ruleForm.oldPassword"
            size="large"
            class="w300"
          />
        </a-form-model-item> -->
        <a-form-model-item label="新密码">
          <a-input-password
            class="w300"
            size="large"
            v-model="ruleForm.newPassword"
          />
        </a-form-model-item>
        <a-form-model-item label="再次输入新密码">
          <a-input-password
            v-model="ruleForm.xnewPassword"
            size="large"
            class="w300"
          />
        </a-form-model-item>
        <blank height="20"> </blank>
        <a-form-model-item :wrapper-col="{ span: 10, offset: 5 }">
          <a-button type="primary" @click="submitForm()"> 确认 </a-button>
          <a-button style="margin-left: 30px" @click="resetForm()">
            取消
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { updatePassword } from './api/api'
export default {
  data() {
    return {
      ruleForm: {
        oldPassword: '',
        xnewPassword: '',
        newPassword: ''
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 10 }
      },
      greetings: '你好'
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo, //用户信息
      dutiesValList: (state) => state.bytype.dutiesValList //职务
    })
  },
  created() {
    this.getdutiesVal()
    let now = new Date()
    let hour = now.getHours()
    if (hour < 6) {
      this.greetings = '凌晨好'
    } else if (hour < 9) {
      this.greetings = '早安'
    } else if (hour < 12) {
      this.greetings = '上午好'
    } else if (hour < 14) {
      this.greetings = '中午好'
    } else if (hour < 17) {
      this.greetings = '下午好'
    } else if (hour < 19) {
      this.greetings = '傍晚好'
    } else if (hour < 22) {
      this.greetings = '晚上好'
    } else {
      this.greetings = '夜里好'
    }
  },
  methods: {
    ...mapActions(['getdutiesVal']),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    getstrength(password) {
      let reg = /\d/
      let a = reg.test(password)
      let p = /[a-z]/
      let b = p.test(password) //true,说明有英文字母
      let c = /[A-Z]/
      let s = c.test(password) //true,说明有大写英文字母
      if (a && b && s) {
        return true
      } else {
        return false
      }
    },
    submitForm() {
      // if (!this.ruleForm.oldPassword) {
      //   this.$message.error('请输入原密码')
      //   return false
      // }
      if (!this.ruleForm.xnewPassword) {
        this.$message.error('请输入新密码')
        return false
      }
      if (this.ruleForm.xnewPassword != this.ruleForm.newPassword) {
        this.$message.error('两次输入密码不一致')
        return false
      }
      if (
        this.ruleForm.xnewPassword.length > 8 ||
        this.ruleForm.xnewPassword.length < 6
      ) {
        this.$message.error('密码由6-8位的大小写字母和数字组成')
        return false
      }
      let isstrength = this.getstrength(this.ruleForm.xnewPassword)
      if (!isstrength) {
        this.$message.error('密码由6-8位的大小写字母和数字组成')
        return false
      }
      updatePassword(this.ruleForm).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('修改成功')
          this.$router.push('/login')
        }
      })
    },
    resetForm() {
      this.ruleForm.oldPassword = ''
      this.ruleForm.xnewPassword = ''
      this.ruleForm.newPassword = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.mine {
  .mine-top {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0 30px 44px;
    img {
      width: 72px;
      height: 72px;
      border-radius: 36px;
    }
    .mine-top-cont {
      margin-left: 25px;
      .mine-name {
        margin-bottom: 5px;
        color: rgba(56, 56, 56, 1);
        font-size: 20px;
      }
      .mine-duty {
        color: rgba(166, 166, 166, 1);
        font-size: 14px;
      }
    }
  }
  .changepassword {
    color: rgba(128, 128, 128, 1);
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/workbench/mine.vue